/**
 * @generated SignedSource<<6c0b207996a75493401d5878751910e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdatePostInput = {
  attachments?: ReadonlyArray<CreatePostAttachment> | null | undefined;
  club?: string | null | undefined;
  commentPolicy?: string | null | undefined;
  content?: string | null | undefined;
  cover?: CreatePostCover | null | undefined;
  hideMetadata?: boolean | null | undefined;
  notifyMembers?: boolean | null | undefined;
  pinned?: boolean | null | undefined;
  pinnedUniversal?: boolean | null | undefined;
  scheduledPublishDate?: any | null | undefined;
  space?: string | null | undefined;
  title?: string | null | undefined;
};
export type CreatePostAttachment = {
  file: string;
};
export type CreatePostCover = {
  coverContent?: string | null | undefined;
  externalCoverVideoUrl?: string | null | undefined;
};
export type postHeader_updatePostMutation$variables = {
  club: string;
  payload: UpdatePostInput;
  slug: string;
};
export type postHeader_updatePostMutation$data = {
  readonly updatePost: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"postPreviewFragment">;
  };
};
export type postHeader_updatePostMutation = {
  response: postHeader_updatePostMutation$data;
  variables: postHeader_updatePostMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "club"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "payload"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v3 = {
  "kind": "Variable",
  "name": "club",
  "variableName": "club"
},
v4 = [
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "payload"
  },
  {
    "kind": "Variable",
    "name": "postSlug",
    "variableName": "slug"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v3/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v13 = [
  (v12/*: any*/),
  (v5/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawID",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playback",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "postHeader_updatePostMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Post",
        "kind": "LinkedField",
        "name": "updatePost",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "args": (v6/*: any*/),
            "kind": "FragmentSpread",
            "name": "postPreviewFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "postHeader_updatePostMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Post",
        "kind": "LinkedField",
        "name": "updatePost",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v7/*: any*/),
              (v5/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledPublishDate",
            "storageKey": null
          },
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PostVote",
            "kind": "LinkedField",
            "name": "userVote",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vote",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "commentCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatarFallback",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "Badge",
                "kind": "LinkedField",
                "name": "badges",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "textColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bgColor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageFile",
                "kind": "LinkedField",
                "name": "photo",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "votes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Club",
            "kind": "LinkedField",
            "name": "club",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SpaceGroup",
                "kind": "LinkedField",
                "name": "groups",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "spaces",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v5/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pinned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pinnedUniversal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "coverContent",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v11/*: any*/)
                ],
                "type": "ExternalVideoCover",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/),
                  (v14/*: any*/),
                  (v9/*: any*/),
                  (v12/*: any*/)
                ],
                "type": "ImageFile",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "muxId",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageFile",
                    "kind": "LinkedField",
                    "name": "thumbnail",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VideoPlayback",
                    "kind": "LinkedField",
                    "name": "playback",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoFileTokens",
                        "kind": "LinkedField",
                        "name": "tokens",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "storyboard",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbnail",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "VideoFile",
                "abstractKey": null
              },
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Attachment",
            "kind": "LinkedField",
            "name": "attachments",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "originalName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ec2ab8686498f68e66ddd7dca43c15e1",
    "id": null,
    "metadata": {},
    "name": "postHeader_updatePostMutation",
    "operationKind": "mutation",
    "text": "mutation postHeader_updatePostMutation(\n  $slug: String!\n  $payload: UpdatePostInput!\n  $club: String!\n) {\n  updatePost(input: $payload, postSlug: $slug, club: $club) {\n    id\n    ...postPreviewFragment_4bIyVY\n  }\n}\n\nfragment memberBadgeFragment on Badge {\n  text\n  textColor\n  bgColor\n}\n\nfragment postAttachmentsPreview_post on Post {\n  id\n  attachments {\n    id\n    originalName\n    size\n    signedUrl\n  }\n}\n\nfragment postBottomActionsFragment on Post {\n  id\n  slug\n  url\n  space {\n    __typename\n    slug\n    id\n  }\n  userVote {\n    vote\n  }\n  commentCount\n  author {\n    id\n  }\n  votes\n}\n\nfragment postContentPreviewFragment on Post {\n  content\n}\n\nfragment postCoverFragment on Post {\n  coverContent {\n    ... on ExternalVideoCover {\n      url\n    }\n    ... on ImageFile {\n      id\n      rawID\n      name\n      signedUrl\n    }\n    ... on VideoFile {\n      id\n      rawID\n      muxId\n      url\n      status\n      thumbnail {\n        signedUrl\n        id\n      }\n      playback {\n        playback\n        tokens {\n          playback\n          storyboard\n          thumbnail\n        }\n      }\n    }\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  id\n}\n\nfragment postHeaderFragment_4bIyVY on Post {\n  id\n  slug\n  author {\n    id\n    displayName\n    username\n    avatarFallback\n    badges(club: $club) {\n      id\n      ...memberBadgeFragment\n    }\n    photo {\n      signedUrl\n      id\n    }\n  }\n  space {\n    __typename\n    id\n    name\n    icon\n    slug\n  }\n  club {\n    id\n    slug\n  }\n  createdAt\n  pinned\n  pinnedUniversal\n  ...postMoveDialogQuery\n}\n\nfragment postMoveDialogQuery on Post {\n  id\n  space {\n    __typename\n    id\n  }\n  club {\n    slug\n    groups {\n      id\n      name\n      spaces {\n        __typename\n        id\n        name\n        icon\n      }\n    }\n    id\n  }\n}\n\nfragment postPreviewFragment_4bIyVY on Post {\n  title\n  slug\n  space {\n    __typename\n    slug\n    id\n  }\n  scheduledPublishDate\n  ...postBottomActionsFragment\n  ...postHeaderFragment_4bIyVY\n  ...postContentPreviewFragment\n  ...postCoverFragment\n  ...postAttachmentsPreview_post\n}\n"
  }
};
})();

(node as any).hash = "10ba28bad31788dacc520fbfab4cf07c";

export default node;
